import { lazy } from 'react';
import type { AppRoute } from 'src/shared/routes';

const FinancePage = lazy(() => import('./FinancePage'));

export const financeRoutes: AppRoute[] = [
  { path: '/finanzas', name: 'Finanzas', element: FinancePage },
];
